import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { modalActions } from '../store/modalSlice';
import { useDeleteBlogMutation } from '../store/services/blogServices';
import { useDeleteAccessoryMutation } from '../store/services/accessoryServices';
import { useDeleteUserMutation } from '../store/services/userServices';
import { useDeleteManyListingsMutation, useSoftDeleteByIdMutation, useRenewListingMutation, useRevertListingMutation } from '../store/services/listingServices';
import { alertActions } from '../store/alertSlice';
import { selectedListingsActions } from '../store/selectedListingsSlice';
import { openModalWithTimeout } from '../store/alertSlice';
import { useDeletePropertyTypeMutation } from '../store/services/propertyTypeServices';
import { useDeleteSubPropertyTypeMutation } from '../store/services/subPropertyServices';
import { useDeleteHeatingTypeMutation } from '../store/services/heatingTypeServices';
import { useDeleteFurnishingTypeMutation } from '../store/services/furnishingTypeServices';
import { useDeleteCharacteristicMutation } from '../store/services/characteristicsServices';
import { useDeleteDeleteReasonMutation } from '../store/services/deleteReasonServices';
import { useDeleteBannerMutation } from '../store/services/bannerServices';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '30px'
    },
    overlay: {
        background: 'rgba(0, 0, 0, 0.8)'
    }
};

Modal.setAppElement(document.getElementById('root'))

export default function ReactModal() {

    const details = useSelector(state => state.modal.details)
    const dispatch = useDispatch()
    const isOpen = useSelector(state => state.modal.isOpen)
    const ids = useSelector(state => state.selectedListings.ids)
    const selectedListings = useSelector(state => state.selectedListings)

    const [deleteBlog] = useDeleteBlogMutation()
    const [deleteAccessory] = useDeleteAccessoryMutation()
    const [deleteUser] = useDeleteUserMutation()
    const [deletePropertyType] = useDeletePropertyTypeMutation()
    const [deleteSubPropertyType] = useDeleteSubPropertyTypeMutation()
    const [deleteHeatingType] = useDeleteHeatingTypeMutation()
    const [deleteFurnishingType] = useDeleteFurnishingTypeMutation()
    const [deleteCharacteristic] = useDeleteCharacteristicMutation()
    const [deleteDeleteReason] = useDeleteDeleteReasonMutation()
    const [deleteBanner] = useDeleteBannerMutation()
    const [softDeleteListing] = useSoftDeleteByIdMutation()
    const [deleteListings] = useDeleteManyListingsMutation()
    const [renewListing] = useRenewListingMutation()
    const [revertListing] = useRevertListingMutation()

    const [isSelectedListingsListOpen, setIsSelectedListingsListOpen] = useState(false)

    function closeModal() {
        dispatch(modalActions.closeModal())
        setIsSelectedListingsListOpen(false)
    }

    const handleCancel = () => {
        dispatch(modalActions.closeModal())
        setIsSelectedListingsListOpen(false)
    }

    const handleRenew = async () => {
        try {
            const response = await renewListing(details.id).unwrap()
            dispatch(openModalWithTimeout({ text: 'Listing renewed successfully!', type: 'success' }))
            dispatch(modalActions.closeModal())
        } catch (error) {
            dispatch(modalActions.closeModal())
            dispatch(openModalWithTimeout({ text: error?.data?.message || 'Failed to renew listing', type: 'error' }))
            console.log(error)
        }
    }

    const handleRevert = async () => {
        try {
            const response = await revertListing(details.id).unwrap()
            dispatch(openModalWithTimeout({ text: response.message || 'Listing restored successfully!', type: 'success' }))
            dispatch(modalActions.closeModal())
        } catch (error) {
            dispatch(modalActions.closeModal())
            dispatch(openModalWithTimeout({ text: error?.data?.message || 'Failed to restore listing', type: 'error' }))
            console.log(error)
        }
    }

    const handleDelete = async () => {
        try {
            if (details.category === 'blog') {
                const response = await deleteBlog(details.id).unwrap()
                dispatch(openModalWithTimeout({ text: response.message, type: 'success' }))
            }
            else if (details.category === 'banner') {
                const response = await deleteBanner(details.id).unwrap()
                dispatch(openModalWithTimeout({ text: response.message, type: 'success' }))
            }
            else if (details.category === 'listing') {
                const response = await softDeleteListing(details.id).unwrap()
                dispatch(openModalWithTimeout({ text: response.message, type: 'success' }))
            }
            else if (details.category === 'tip te prones') {
                const response = await deletePropertyType(details.id).unwrap()
                dispatch(openModalWithTimeout({ text: response.message, type: 'success' }))
            }
            else if (details.category === 'nentip te prones') {
                const response = await deleteSubPropertyType(details.id).unwrap()
                dispatch(openModalWithTimeout({ text: response.message, type: 'success' }))
            }
            else if (details.category === 'sistem te ngrohjes') {
                const response = await deleteHeatingType(details.id).unwrap()
                dispatch(openModalWithTimeout({ text: response.message, type: 'success' }))
            }
            else if (details.category === 'mobilim') {
                const response = await deleteFurnishingType(details.id).unwrap()
                dispatch(openModalWithTimeout({ text: response.message, type: 'success' }))

            }
            else if (details.category === 'karakteristike') {
                const response = await deleteCharacteristic(details.id).unwrap()
                dispatch(openModalWithTimeout({ text: response.message, type: 'success' }))
            }
            else if (details.category === 'arsye te fshirjes') {
                const response = await deleteDeleteReason(details.id).unwrap()
                dispatch(openModalWithTimeout({ text: response.message, type: 'success' }))
            }
            else if (details.category === 'user') {
                const response = await deleteUser(details.id).unwrap()
                dispatch(openModalWithTimeout({ text: response.message, type: 'success' }))
            }
            else if (details.category === 'listings') {
                const response = await deleteListings(ids).unwrap()
                dispatch(openModalWithTimeout({ text: response.message, type: 'success' }))
                dispatch(selectedListingsActions.clearSelectedListings())
            }
            dispatch(modalActions.closeModal())
            setIsSelectedListingsListOpen(false)
            // openModalWithTimeout({ text: 'Operation completed successfully', type: 'success' });
        } catch (error) {
            dispatch(modalActions.closeModal())
            dispatch(openModalWithTimeout({ text: error?.data?.message || 'Failed to delete', type: 'error' }))
            console.log(error)
        }
    }

    // Revert soft-deletion modal
    if (details.action === 'revert' && details.category === 'listing') {
        return (
            <div>
                <Modal
                    isOpen={isOpen}
                    onRequestClose={closeModal}
                    style={customStyles}
                    contentLabel="Restore Listing Modal"
                >
                    <div className="bg-white p-6 px-8 w-[650px]">
                        <h1 className="text-xl text-[#667085] leading-8">A jeni te sigurt qe deshironi ta riktheni kete listing?</h1>
                        <h3 className="text-sm text-gray-400 mt-4">Listingu <span className="text-black font-semibold">"{details.name}"</span> do te kthehet nga arkiva dhe do te shfaqet perseri tek listingjet.</h3>
                        <div className="flex justify-between mt-8">
                            <div className="p-1 px-6 rounded-full cursor-pointer border border-gray-200 hover:bg-gray-100" onClick={handleCancel}>Cancel</div>
                            <div className="p-1 px-6 bg-primary text-white rounded-full cursor-pointer hover:opacity-90" onClick={handleRevert}>Rikthe</div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }

    // Renew listing modal
    if (details.action === 'renew' && details.category === 'listing') {
        return (
            <div>
                <Modal
                    isOpen={isOpen}
                    onRequestClose={closeModal}
                    style={customStyles}
                    contentLabel="Renew Listing Modal"
                >
                    <div className="bg-white p-6 px-8 w-[650px]">
                        <h1 className="text-xl text-[#667085] leading-8">A jeni te sigurt qe deshironi te rinovoni kete listing?</h1>
                        <h3 className="text-sm text-gray-400 mt-4">A jeni te sigurt qe deshironi te rinovoni <span className="text-black font-semibold">"{details.name}"</span>? Kjo do te perditesoje daten e krijimit.</h3>
                        <div className="flex justify-between mt-8">
                            <div className="p-1 px-6 rounded-full cursor-pointer border border-gray-200 hover:bg-gray-100" onClick={handleCancel}>Cancel</div>
                            <div className="p-1 px-6 bg-primary text-white rounded-full cursor-pointer hover:opacity-90" onClick={handleRenew}>Renew</div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }

    if (details.category === 'listings') {
        return (
            <div>
                <Modal
                    isOpen={isOpen}
                    onRequestClose={closeModal}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="bg-white p-6 px-8 w-[650px]">
                        <h1 className="text-[25px] text-[#667085] leading-8">A jeni te sigurt qe deshironi te fshini keto {details.category}?</h1>
                        <h3 className="text-sm text-gray-400 mt-4">A jeni te sigurt qe deshironi te fshini keto <span className="text-black font-semibold cursor-pointer hover:underline    " onClick={() => setIsSelectedListingsListOpen(!isSelectedListingsListOpen)}>{details.name}?</span></h3>
                        <div className={`${isSelectedListingsListOpen ? 'max-h-48 mt-4' : 'max-h-0'} transition-all text-sm overflow-y-scroll scrollbar-thin scrollbar-track scrollbar-thumb`}>
                            <table className='w-full'>
                                <thead>
                                    <tr className='bg-gray-100 sticky top-0'>
                                        <td className='p-1'>#</td>
                                        <td>ID</td>
                                        <td>Name</td>
                                        <td>User</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedListings.listings.map((listing, index) => (
                                        <tr>
                                            <td className='w-[10%] p-2'>{index + 1}</td>
                                            <td className='w-[15%]'>{listing.listing_id}</td>
                                            <td className='w-[50%]'>{listing.title}</td>
                                            <td className='w-[30%]'>{listing.user_name}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="flex justify-between mt-8">
                            <div className="p-2 px-6 rounded-full cursor-pointer border border-gray-200 hover:bg-gray-100"
                                onClick={handleCancel}>
                                Cancel
                            </div>
                            <div className="p-2 px-6 bg-[#EB0000] text-white rounded-full cursor-pointer hover:bg-red-600"
                                onClick={handleDelete}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") handleDelete();
                                }}>
                                Delete
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }

    return (
        <div>
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className="bg-white lg:p-6 p-2 px-8 lg:w-[650px] w-[80dvw]">
                    <h1 className="lg:text-xl text-normal text-[#667085]">A jeni te sigurt qe deshironi te fshini kete {details.category}?</h1>
                    <h3 className="text-sm text-gray-400 mt-4">A jeni te sigurt qe deshironi te fshini <span className="text-black font-semibold">{details.name}?</span></h3>
                    <div className="flex justify-between mt-8">
                        <div className="p-1 px-6 rounded-full cursor-pointer border border-gray-200 hover:bg-gray-100" onClick={handleCancel}>Cancel</div>
                        <div className="p-1 px-6 bg-[#EB0000] text-white rounded-full cursor-pointer hover:bg-red-600" onClick={handleDelete}>Delete</div>
                    </div>
                </div>
            </Modal>
        </div>)
}